import {t} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {ViewerSettingResetContentOptionsProps} from './ViewerSettingResetContentOptionsProps.interface';

export function ViewerSettingResetContentOptions({
  isMobile,
  onClickResetContentOptions,
}: ViewerSettingResetContentOptionsProps) {
  return (
    <div
      className={twMerge(
        'flex h-18pxr items-center justify-center',
        isMobile ? 'mt-6pxr' : 'mt-10pxr'
      )}
    >
      <div
        className="flex h-full cursor-pointer items-center"
        onClick={onClickResetContentOptions}
      >
        <Text className="font-small2 mr-4pxr text-theme-solid-60">
          {t('viewer_setting_reset')}
        </Text>
        <Icon type={IconType.ViewerSettingRefresh} />
      </div>
    </div>
  );
}
